const { useEffect, useState } = wp.element;

import { registerLocale } from 'react-datepicker'

import nb from 'date-fns/locale/nb';
registerLocale('nb', nb)

import SyncLoader from 'react-spinners/SyncLoader';

import BookingByResource from './components/BookingByResource'
import BookingByService from './components/BookingByService'

import ConfirmModal from './components/ConfirmModal'

import Department from './components/steps/Department'
import BookingType from './components/steps/BookingType'

const App = () => {
    const [loading, setLoading] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [user, setUser] = useState(null);
    const [bookingData, setBookingData] = useState(null);
    const [additionalServicesOptions, setAdditionalServicesOptions] = useState([]);
    
    const [servicesData, setServicesData] = useState(null);

    const [duration, setDuration] = useState(null);
    const [price, setPrice] = useState(null);

    const [department, setDepartment] = useState(null);
    const [bookingType, setBookingType] = useState(null);
    const [category, setCategory] = useState(null);
    const [service, setService] = useState(null);
    const [serviceData, setServiceData] = useState(null);
    const [hasAdditionalServices, setHasAdditionalServices] = useState(null);
    const [additionalServices, setAdditionalServices] = useState([]);
    const [employee, setEmployee] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);
    const [date, setDate] = useState(null);
    const [timeslot, setTimeslot] = useState(null);

    const [loadingEmployees, setLoadingEmployees] = useState(false);
    const [employees, setEmployees] = useState([]);
    
    const [availableTimeslots, setAvailableTimeslots] = useState([]);
    const [loadingAvailableTimeslots, setLoadingAvailableTimeslots] = useState(false);

    const [loadingBooking, setLoadingBooking] = useState(false);

    const [additionalServicesData, setAdditionalServicesData] = useState([]);

    useEffect(() => {
        getUserData()
        getBookingData()
        getAdditionalServicesOptions()
    }, [])

    // get user when Alpine store isLoggedIn is updated
    useEffect(() => {
        if (Alpine.store('globalData').isLoggedIn) {
            getUserData()
        }
    }, [Alpine.store('globalData').isLoggedIn])

    // resets data when department is changed
    useEffect(() => {
        setDuration(null)
        setPrice(null)
        setCategory(null)
        setService(null)
        setBookingType(null)
        setDate(null)
        setTimeslot(null)
        setAvailableTimeslots([])
        setEmployee(null)

        console.log('department', department)

        if (department) {
            getServicesData()

            // scroll down to next section
            const nextSection = document.getElementById('section-booking-type')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [department])

    // resets data when bookingType is changed
    useEffect(() => {
        setDuration(null)
        setPrice(null)
        setAdditionalServices([])
        setDate(null)
        setTimeslot(null)
        setAvailableTimeslots([])
        setEmployee(null)
    }, [bookingType])
    
    // resets data when additionalServices is changed
    useEffect(() => {
        setDuration(null)
        setPrice(null)
        setDate(null)
        setTimeslot(null)
        setAvailableTimeslots([])
        
        if (bookingType === 'service') {
            setEmployee(null)
        }

        const additionalServicesDataTmp = []
        if (additionalServices?.length > 0) {
            additionalServices.forEach(item => {
                const service = servicesData?.find(service => String(service.id) === String(item['hano-id']))
                additionalServicesDataTmp.push(service)
            })
            setAdditionalServicesData(additionalServicesDataTmp)
        } else {
            setAdditionalServicesData([])
        }
    }, [additionalServices])
    
    // get employees when booking type is resource
    useEffect(() => {
        if (department) {
            getEmployees()
        }
    }, [bookingType])
    
    // get available dates when service and employees loaded
    useEffect(() => {
        if (bookingType === 'service' && service && employees && employees.length > 0) {
            handleGetAvailableDates()
        }
    }, [service, additionalServices])
    
    // get available dates when employees loaded
    useEffect(() => {
        if (bookingType === 'resource' && service && employee) {
            handleGetAvailableDates()
        }
    }, [service, additionalServices])

    // get service data when service is changed
    useEffect(() => {
        console.log('service', service)
        if (service) {
            getServiceData()
        }
    }, [service])

    // gets available timeslots when date is changed
    useEffect(() => {
        setDuration(null)
        setPrice(null)
        setTimeslot(null)
        setAvailableTimeslots([])
        
        if (date) {
            getAvailableTimeslots()
        }

        if (window.innerWidth < 768) {
            // scroll down to next section
            const nextSection = document.getElementById('section-time')

            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [date])

    useEffect(() => {
        if (bookingType === 'resource' && timeslot && employee) {
            const sumDuration = timeslot.items[0]?.service?.duration + timeslot.items[0]?.additionalServices?.reduce((a, b) => a + b.service.duration, 0)
            const sumPrice = timeslot.items[0]?.service?.price + timeslot.items[0]?.additionalServices?.reduce((a, b) => a + b.service.price, 0)

            setDuration(sumDuration)
            setPrice(sumPrice)
        }
    }, [timeslot])

    useEffect(() => {
        if (bookingType === 'service' && timeslot && employee) {
            const sumDuration = employee?.service?.duration + employee?.additionalServices?.reduce((a, b) => a + b.service.duration, 0)
            const sumPrice = employee?.service?.price + employee?.additionalServices?.reduce((a, b) => a + b.service.price, 0)

            setDuration(sumDuration)
            setPrice(sumPrice)
        }
    }, [employee])

    async function getBookingData() {
        setLoading(true)

        var formData = new FormData()
        formData.append('action', 'getBookingData');

        const response = await fetch(document.getElementById('admin-ajax-url').value, {
            method: 'POST',
            body: formData,
        })
        
        const data = await response.json()

        setBookingData(data)
        setLoading(false)

        /* ------------------------------ */
        /*  Dev test                      */
        /* ------------------------------ */
        // setDepartment(data?.departments?.[1])
        // setTimeout(() => {
        //     setBookingType('service')

        //     setTimeout(() => {
        //         setCategory('cut')
                
        //         setTimeout(() => {
        //             setService(data?.cut?.items?.[0])
                    
        //             setTimeout(() => {
        //                 setHasAdditionalServices(true)

        //                 setTimeout(() => {
        //                     // setAdditionalServices([additionalServicesOptions[0], additionalServicesOptions[1]])

        //                     // setTimeout(() => {
        //                         window.scrollTo(0, document.body.scrollHeight)
        //                     // }, 300)
        //                 }, 300)
        //             }, 300)
        //         }, 300)
        //     }, 300)
        // }, 300)
        /* ------------------------------ */
        /*  Dev test                      */
        /* ------------------------------ */
    }
    
    async function getUserData() {
        var formData = new FormData()
        formData.append('action', 'getUserData');

        const response = await fetch(document.getElementById('admin-ajax-url').value, {
            method: 'POST',
            body: formData,
        })
        
        const data = await response.json()

        setUser(data)
    }

    async function getServiceData() {
        var formData = new FormData()
        formData.append('action', 'getServiceData');
        formData.append('departmentId', department?.ref);
        formData.append('serviceId', service?.['hano-id']);

        const response = await fetch(document.getElementById('admin-ajax-url').value, {
            method: 'POST',
            body: formData,
        })

        const json = await response.json()
    
        if (json?.response?.code === 200) {
            setServiceData(JSON.parse(json.body))
        }
    }

    async function getServicesData() {
        var formData = new FormData()
        formData.append('action', 'getServicesData');
        formData.append('departmentId', department?.ref);

        const response = await fetch(document.getElementById('admin-ajax-url').value, {
            method: 'POST',
            body: formData,
        })

        const json = await response.json()
    
        if (json?.response?.code === 200) {
            setServicesData(JSON.parse(json.body))
        }
    }

    async function getAdditionalServicesOptions() {
        var formData = new FormData()
        formData.append('action', 'getAdditionalServices');
        formData.append('departmentId', department?.ref);

        const response = await fetch(document.getElementById('admin-ajax-url').value, {
            method: 'POST',
            body: formData,
        })

        const json = await response.json()

        if (json?.items) {
            setAdditionalServicesOptions(json.items)
        }
    }

    async function getEmployees() {
        setLoadingEmployees(true)
        setEmployees([])

        var formData = new FormData()
        formData.append('action', 'getEmployees');
        formData.append('departmentId', department?.ref);

        try {
            const response = await fetch(document.getElementById('admin-ajax-url').value, {
                method: 'POST',
                body: formData,
            })
    
            const json = await response.json()
    
            if (json?.response?.code === 200) {
                const data = JSON.parse(json.body)
                setEmployees(data)

                console.log('employees', data)

            } else if (json?.response?.code === 401) {
                var logoutFormData = new FormData()
                logoutFormData.append('action', 'logout');
                
                const response = await fetch(document.getElementById('admin-ajax-url').value, {
                    method: 'POST',
                    body: logoutFormData,
                })
            }
    
            setLoadingEmployees(false)
        } catch (error) {
            console.log('error', error)

            setLoadingEmployees(false)
        }
    }
    
    async function getAvailableTimeslots() {
        setLoadingAvailableTimeslots(true)

        let requestedServices = {}

        const fields = [
            { requestId: 'frisor', fieldKey: 'hano-id' },
            { requestId: 'senior', fieldKey: 'hano-id-senior' },
            { requestId: 'elite', fieldKey: 'hano-id-elite' },
            { requestId: 'larling2', fieldKey: 'hano-id-larling-2' },
            { requestId: 'larling3', fieldKey: 'hano-id-larling-3' },
            { requestId: 'larling4', fieldKey: 'hano-id-larling-4' },
        ]

        fields.forEach(field => {
            let add = false
            let mainId = null
            let additionalIds = []
            
            if (service?.[field.fieldKey]) {
                add = true
                mainId = Number(service?.[field.fieldKey])

                if (additionalServices.length > 0) {
                    additionalIds = additionalServices.map(item => Number(item[field.fieldKey]))
                }

            } else if (service?.[field.fieldKey] && additionalServices.length > 0) {
                add = true
                mainId = Number(service?.[field.fieldKey])
                additionalIds = additionalServices.map(item => Number(item[field.fieldKey]))
            }

            if (add) {
                requestedServices[field.requestId] = {
                    main: mainId,
                    additional: additionalIds,
                }
            }
        })

        var formData = new FormData()
        formData.append('action', 'getAvailableTimeslots');
        formData.append('departmentId', department?.ref);
        formData.append('startDate', date?.toISOString());
        formData.append('services', JSON.stringify(requestedServices));

        if (employee) {
            formData.append('resourceId', employee?.id);
        }

        try {
            const response = await fetch(document.getElementById('admin-ajax-url').value, {
                method: 'POST',
                body: formData,
            })
    
            const json = await response.json()
    
            if (json?.response?.code === 200) {
                const data = JSON.parse(json.body)

                console.log('data', data)

                let timeslots = data?.timeSlots
                const resources = data?.resources
                const services = data?.services

                let alteredTimeslots = []

                for (const [key, value] of Object.entries(timeslots)) {
                    let alteredTimeslot = {
                        startLocal: key,
                        items: value,
                    }
                    
                    // iterate over items and add resource and service
                    for (let i = 0; i < alteredTimeslot.items.length; i++) {
                        const resource = resources.find(item => String(item.id) === String(alteredTimeslot.items[i].resourceId))
                        const s = services.find(item => String(item.id) === String(alteredTimeslot.items[i].main.serviceId))

                        if (alteredTimeslot.items[i].additionalServices?.length > 0) {
                            alteredTimeslot.items[i].additionalServices.forEach((x, index) => {
                                const s = services.find(item => String(item.id) === String(x.serviceId))
                                alteredTimeslot.items[i].additionalServices[index].service = s
                            })
                        }

                        alteredTimeslot.items[i].service = s
                        alteredTimeslot.items[i].resource = {
                            ...resource,
                            service: s,
                            additionalServices: alteredTimeslot.items[i].additionalServices,
                        }
                    }

                    // only keep first item for each resourceId
                    alteredTimeslot.items = alteredTimeslot.items.filter((item, index, self) =>
                        index === self.findIndex((t) => (
                            t.resourceId === item.resourceId
                        ))
                    )

                    alteredTimeslots.push(alteredTimeslot)
                }

                // order by startLocal
                alteredTimeslots.sort((a, b) => {
                    return new Date(a.startLocal) - new Date(b.startLocal)
                })
    
                setAvailableTimeslots(alteredTimeslots)
            }
    
            setLoadingAvailableTimeslots(false)
        } catch (error) {
            console.log('error', error)
            setLoadingAvailableTimeslots(false)
        }
    }

    async function handleGetAvailableDates() {
        setAvailableDates([])

        if (bookingType === 'resource' && employee && service) {
            getAvailableDates([employee.id], 10, 0, [])
        } else if (bookingType === 'service' && employees && employees.length > 0 && service) {
            getAvailableDates(employees.map(item => item.id), 10, 0, [])
        }
    }

    async function getAvailableDates(resourceIds, remainingRuns, skip = 0, items) {
        let itemsAtATime = 10

        try {
            const duration = servicesData?.find(item => String(item.id) === String(service?.['hano-id']))?.duration + (additionalServices?.reduce((a, b) => a + servicesData?.find(item => String(item.id) === String(b['hano-id']))?.duration, 0) || 0)

            var formData = new FormData()

            let startDate = new Date()
            startDate.setDate(startDate.getDate() + skip)

            let endDate = new Date()
            endDate.setDate(endDate.getDate() + skip + itemsAtATime)

            formData.append('action', 'getAvailableDates');
            formData.append('resourceIds', resourceIds);
            formData.append('startDate', startDate.toISOString());
            formData.append('endDate', endDate.toISOString());
            formData.append('duration', duration);
            formData.append('departmentId', department?.ref);

            const response = await fetch(document.getElementById('admin-ajax-url').value, {
                method: 'POST',
                body: formData,
            })

            const json = await response.json()

            if (json?.response?.code === 200) {
                setAvailableDates(items ? [...items, ...JSON.parse(json.body)] : JSON.parse(json.body))

                if (remainingRuns > 0) {
                    getAvailableDates(resourceIds, remainingRuns - 1, skip + itemsAtATime, items ? [...items, ...JSON.parse(json.body)] : JSON.parse(json.body))
                } else {
                }
            } else {
                console.log('error', json)
                setAvailableDates([])
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    function handleClickBook() {
        if (user || Alpine.store('globalData').isLoggedIn) {
            setShowConfirmModal(true)
        } else {
            Alpine.store('globalData').setShowAuthModal(true)
        }
    }

    async function handleConfirmBooking() {
        setLoadingBooking(true)

        try {
            const timeslotData = timeslot?.items?.filter(item => String(item.resourceId) === String(employee.id))[0]

            let activities = []

            activities.push({
                date: timeslotData?.main?.start,
                timeId: timeslotData?.main?.slotId,
                serviceId: timeslotData?.main?.serviceId,
                serviceName: service?.name,
                resourceId: employee?.id,
                estimatedCost: bookingType === 'resource' ? serviceData?.price : employee?.service?.price,
                serviceDurationInMinutes: timeslotData?.service?.duration,
            })

            if (timeslotData?.additionalServices?.length > 0) {
                timeslotData?.additionalServices?.forEach(item => {
                    activities.push({
                        date: item.start,
                        timeId: item?.slotId,
                        serviceId: item?.serviceId,
                        resourceId: employee?.id,
                        serviceName: item?.service?.name,
                        estimatedCost: item?.service?.price,
                        serviceDurationInMinutes: item?.service?.duration,
                    })
                })
            }

            var formData = new FormData()
            formData.append('action', 'book');
            formData.append('departmentId', department?.ref);
            formData.append('activities', JSON.stringify(activities));

            const response = await fetch(document.getElementById('admin-ajax-url').value, {
                headers: {
                    'x-access-token': user?.accessToken,
                    'x-department-id': department?.ref,
                },
                method: 'POST',
                body: formData,
            })
            
            const data = await response.json()

            if (data?.response?.code === 201) {
                window.location = '/min-side';
                
            } else if (data?.response?.code === 401) {
                var logoutFormData = new FormData()
                logoutFormData.append('action', 'logout');
                
                const response = await fetch(document.getElementById('admin-ajax-url').value, {
                    method: 'POST',
                    body: logoutFormData,
                })

                // window.location.reload()
            } else {
                console.log('error', data)
                alert('Noe gikk galt. Vennligst prøv igjen.')
            }

            setLoadingBooking(false)
        } catch (error) {
            console.log('error', error)
            setLoadingBooking(false)
            alert('Noe gikk galt. Vennligst prøv igjen.')
        }
    }

    function addOrRemoveAdditionalService(additionalService) {
        if (additionalServices?.includes(additionalService)) {
            setAdditionalServices(additionalServices.filter(item => item !== additionalService))
        } else {
            setAdditionalServices([...additionalServices, additionalService])
        }
    }
    
    return (
        <>
            {
                loading &&
                <div className="loading-wrapper">
                    <SyncLoader color={'#aaa'} loading={true} size={7} />
                </div>
            }

            {
                showConfirmModal &&
                !loading &&
                user &&
                department &&
                category &&
                service &&
                timeslot &&
                <ConfirmModal 
                    department={department}
                    service={service}
                    timeslot={timeslot}
                    setShowConfirmModal={setShowConfirmModal}
                    handleConfirmBooking={handleConfirmBooking}
                    loadingBooking={loadingBooking}
                    additionalServicesData={additionalServicesData}
                />
            }

            {
                !loading &&
                // user &&
                <>
                    {                    
                        /* ------------------------------ */
                        /*  Department                    */
                        /* ------------------------------ */
                    }
                    <Department 
                        bookingData={bookingData}
                        department={department}
                        setDepartment={setDepartment}
                    />
                    
                    {
                        /* ------------------------------ */
                        /*  Type                          */
                        /* ------------------------------ */
                        bookingData &&
                        department &&
                        <BookingType 
                            bookingType={bookingType}
                            setBookingType={setBookingType}
                        />
                    }

                    {
                        /* ------------------------------ */
                        /*  Booking by resource           */
                        /* ------------------------------ */
                        bookingData &&
                        bookingType &&
                        department &&
                        department.ref !== 'dale' &&
                        bookingType === 'resource' &&
                        <BookingByResource 
                            bookingData={bookingData}
                            department={department} 
                            bookingType={bookingType}
                            loadingEmployees={loadingEmployees} 
                            employees={employees}
                            employee={employee} 
                            setEmployee={setEmployee} 
                            category={category} 
                            setCategory={setCategory}
                            service={service} 
                            setService={setService}
                            hasAdditionalServices={hasAdditionalServices}
                            setHasAdditionalServices={setHasAdditionalServices}
                            additionalServicesOptions={additionalServicesOptions}
                            additionalServices={additionalServices}
                            setAdditionalServices={setAdditionalServices}
                            addOrRemoveAdditionalService={addOrRemoveAdditionalService}
                            handleGetAvailableDates={handleGetAvailableDates}
                            availableDates={availableDates}
                            date={date} 
                            setDate={setDate} 
                            timeslot={timeslot} 
                            setTimeslot={setTimeslot}
                            loadingAvailableTimeslots={loadingAvailableTimeslots}
                            availableTimeslots={availableTimeslots}
                            servicesData={servicesData}
                        />
                    }
                    
                    {
                        /* ------------------------------ */
                        /*  Booking by resource           */
                        /* ------------------------------ */
                        bookingData &&
                        bookingType &&
                        department &&
                        department.ref !== 'dale' &&
                        bookingType === 'service' &&
                        <BookingByService
                            bookingData={bookingData}
                            department={department} 
                            bookingType={bookingType} 
                            category={category} 
                            setCategory={setCategory}
                            service={service} 
                            setService={setService}
                            hasAdditionalServices={hasAdditionalServices}
                            setHasAdditionalServices={setHasAdditionalServices}
                            additionalServices={additionalServices}
                            setAdditionalServices={setAdditionalServices}
                            additionalServicesOptions={additionalServicesOptions}
                            addOrRemoveAdditionalService={addOrRemoveAdditionalService}
                            handleGetAvailableDates={handleGetAvailableDates}
                            availableDates={availableDates}
                            date={date} 
                            setDate={setDate} 
                            timeslot={timeslot} 
                            setTimeslot={setTimeslot}
                            loadingAvailableTimeslots={loadingAvailableTimeslots}
                            availableTimeslots={availableTimeslots}
                            employee={employee} 
                            setEmployee={setEmployee} 
                        />
                    }

                    {
                        /* ------------------------------ */
                        /*  Statusbar                     */
                        /* ------------------------------ */
                        bookingData &&
                        department &&
                        category &&
                        service &&
                        <div className="statusbar">
                            <div className="container">
                                <div className="status-text">
                                    <div className="status-text-top">
                                        {
                                            department &&
                                            <span>
                                                <strong>{department?.name}</strong>
                                            </span>
                                        }

                                        {
                                            date &&
                                            <>
                                                <span>{new Date(date).toLocaleDateString('no-NO', { weekday: 'long', day: 'numeric', month: 'long' })}</span>

                                                {
                                                    timeslot &&
                                                    <> kl {new Date(timeslot?.startLocal).toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit' })}</>
                                                }
                                            </>
                                        }

                                        {
                                            employee &&
                                            <span>{employee?.name}</span>
                                        }
                                    </div>
                                    <div className="status-text-bottom">
                                        {
                                            service &&
                                            <span>
                                                {service?.name}
                                                {
                                                    additionalServicesData?.length > 0 &&
                                                    <>
                                                        <em> +</em>
                                                        {
                                                            additionalServicesData.map((item, index) => (
                                                                <em key={index}> {item?.name}
                                                                    {
                                                                        index < additionalServicesData.length - 1 &&
                                                                        <>, </>
                                                                    }
                                                                </em>
                                                            ))
                                                        }
                                                    </>
                                                }
                                            </span>
                                        }


                                        {
                                            duration &&
                                            <span>
                                                ca {duration} min</span>
                                        }

                                        {
                                            price &&
                                            <span>{price} kr</span>
                                        }
                                    </div>
                                </div>
                                <div className="confirm">
                                    <button 
                                        className="button color--blue size--small" 
                                        disabled={
                                            !date ||
                                            !timeslot ||
                                            !employee ||
                                            loadingBooking
                                        }
                                        onClick={() => { handleClickBook() }}
                                    >
                                        { loadingBooking ? 'Vennligst vent...' : 'Bestill time'  }
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                </>
            }
        </>
    );
};
export default App;